var style = document.createElement('style');
style.innerHTML = `
.product-add-to-cart-sticky {
    transition: all 0.5s ease-in-out;
    opacity: 0;
}
.product-add-to-cart-sticky.visible {
    opacity: 1;
    transform: translateY(0);
}
`;
document.head.appendChild(style);

var mainAddToCart = document.querySelector('.main-addtocart');
var stickyAddToCart = document.querySelector('.product-add-to-cart-sticky');

if (mainAddToCart && stickyAddToCart) {
    var observer = new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
            stickyAddToCart.classList.remove('visible');
        } else {
            stickyAddToCart.classList.add('visible');
        }
    }, { threshold: [0] });

    observer.observe(mainAddToCart);
}
